export const GET_TRANSLATIONS = 'get-translations';
const getTranslations = ({ app, locale = null }) => ({
  type: GET_TRANSLATIONS,
  payload: { app, locale },
});
export default getTranslations;

